<template>
  <div class="wechat-guide">
    <div class="wechat-guide__arrow">↗</div>
    <div class="wechat-guide__hint">{{ $t('WechatOpenGuide.tip') }}</div>

    <m-card class="wechat-guide__card" :title="$t('WechatOpenGuide.title')">
      <div class="wechat-guide__desc">{{ $t('WechatOpenGuide.desc') }}</div>
      <div class="wechat-guide__link">{{ displayLink }}</div>
      <div class="wechat-guide__actions">
        <m-button type="primary" @click="copyLink">
          {{ $t('WechatOpenGuide.copy') }}
        </m-button>
      </div>
    </m-card>
  </div>
</template>

<script>
export default {
  name: 'WechatOpenGuidePage',
  computed: {
    displayLink() {
      return `${window.location.toString().replace("wechat-open-guide", "")}`;
    },
  },
  methods: {
    async copyLink() {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(this.displayLink);
        } else {
          const input = document.createElement('input');
          input.value = this.displayLink;
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
        }
        this.$message.success(this.$t('WechatOpenGuide.copySuccess'))

      } catch (error) {
        this.$error(this.$t('WechatOpenGuide.copyFailed'));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wechat-guide {
  position: relative;
  min-height: 100vh;
  padding: 24px 16px;
  background: #f5f7fa;
}

.wechat-guide__arrow {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 78px;
  line-height: 1;
  color: #1aad19;
  font-weight: 700;
  transform: rotate(6deg);
}

.wechat-guide__hint {
  margin-top: 90px;
  margin-bottom: 14px;
  text-align: right;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}

.wechat-guide__card {
  max-width: 520px;
  margin: 0 auto;
  border-radius: 12px;
}

.wechat-guide__desc {
  font-size: 14px;
  color: #606266;
  margin-bottom: 12px;
  line-height: 1.6;
}

.wechat-guide__link {
  word-break: break-all;
  border-radius: 8px;
  background: #f2f3f5;
  padding: 10px 12px;
  color: #303133;
  font-size: 14px;
}

.wechat-guide__actions {
  margin-top: 16px;
  text-align: right;
}

@media screen and (max-width: 767px) {
  .wechat-guide {
    padding: 20px 12px;
  }

  .wechat-guide__arrow {
    right: 14px;
    font-size: 64px;
  }

  .wechat-guide__hint {
    margin-top: 76px;
    font-size: 15px;
  }
}
</style>
